// Rxjs imports
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
export class ConfigurationService {
    constructor() {
        this._subjectForceRefresh = new Subject();
        this._subjectContext = new Subject(); // to send selected context (ex: M1, L10...) to component in router-outlet
    }
    getSubjectForceRefresh() {
        return this._subjectForceRefresh;
    }
    updateSubjectForceRefresh(flag) {
        this._subjectForceRefresh.next(flag);
    }
    getSubjectContext() {
        return this._subjectContext;
    }
    updateSubjectContext(newContext) {
        this._subjectContext.next(newContext);
    }
}
ConfigurationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfigurationService_Factory() { return new ConfigurationService(); }, token: ConfigurationService, providedIn: "root" });
